export var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-portal/es/utils.js
// module id = 1657
// module chunks = 0